import React, { useRef, useEffect } from 'react';
import { i18n } from 'utils/i18n';
import { scrollPage } from 'utils/dom';
import SCROLL from 'constants/scroll';

const FormErrors = () => {
  const formErrorsRef = useRef(null);

  useEffect(() => {
    const { current } = formErrorsRef;
    const currentOffsetTop = current?.offsetTop;
    setTimeout(() => scrollPage(0, currentOffsetTop - SCROLL.HEADER_CLEARANCE));
  }, [formErrorsRef.current]);

  return (
    <div className='service-errors' ref={formErrorsRef}>
      <div className='service-error'>
        <span className='message-priority--ERROR'>{i18n('message_priority_ERROR')}</span>
        <p>{i18n('review_form_error_message')}</p>
      </div>
    </div>
  );
};

export default FormErrors;
